import { environment } from 'src/enviroments';
import { HttpHandler } from './HttpHandler';
import { parseAttributionParams } from 'src/utils/parseAttributionParams';

export const updateUserMetadataAnalyticsParams = async () => {
  try {
    const attributionParams = parseAttributionParams();
    await HttpHandler({
      method: 'POST',
      url: `${environment.USER_METADATA_V2_URL}/user-metadata`,
      data: {
        tiktokBrowserId: attributionParams.ttPixelId,
        tiktokClickId: attributionParams.ttClickId,
        facebookBrowserId: attributionParams.fbPixelId,
        facebookClickId: attributionParams.fbClickId,
        utmParams: attributionParams.utm_params,
      },
    });
  } catch (error) {}
};
